var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHalfH(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 336,
    viewBox: "0 0 224 336",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2127_120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.854 1H12.1464C5.99043 1 1 6.35654 1 12.9642V323.036C1 329.643 5.99043 335 12.1464 335H211.854C218.01 335 223 329.643 223 323.036V12.9642C223 6.35654 218.01 1 211.854 1Z",
    fill: "white",
    stroke: "#0B0B0B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2127_120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 25C37 21 42 17 47 17C52 17 57 21 57 27C57 37 37 53 37 57C37 53 17 37 17 27C17 21 22 17 27 17C32 17 37 21 37 25Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2127_120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.491 152.342C126.434 149.56 128.811 135.994 139.376 135.994C149.941 135.994 151.262 145.386 151.262 152.342C151.262 166.255 127.491 179.125 127.491 199.994H151.262V188.864",
    stroke: "black",
    strokeWidth: 9,
    strokeMiterlimit: 1.5,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2127_120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.262 127.484L96.9406 208.989",
    stroke: "black",
    strokeWidth: 9,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M82.2 135.021C82.2065 136.115 82.2065 136.115 82.2131 137.231C82.2546 144.105 82.3012 150.979 82.3533 157.852C82.38 161.386 82.4047 164.92 82.425 168.454C82.4447 171.864 82.4694 175.275 82.4976 178.685C82.5075 179.986 82.5156 181.287 82.5218 182.588C82.5308 184.411 82.5463 186.233 82.5633 188.056C82.5704 189.093 82.5775 190.131 82.5848 191.199C82.7299 193.8 82.9058 195.303 83.8 197.428C85.4224 198.58 85.4224 198.58 87 199.211C87 199.8 87 200.388 87 200.994C81.896 200.994 76.792 200.994 71.5333 200.994C71.5333 200.406 71.5333 199.818 71.5333 199.211C73.9093 198.329 73.9093 198.329 76.3333 197.428C76.358 190.849 76.377 184.269 76.3886 177.69C76.3942 174.634 76.4017 171.579 76.4138 168.524C76.4276 165.012 76.4328 161.501 76.4375 157.989C76.443 156.891 76.4485 155.793 76.4542 154.662C76.4543 153.136 76.4543 153.136 76.4544 151.58C76.4568 150.683 76.4592 149.786 76.4616 148.862C76.428 146.391 76.428 146.391 75.2667 143.937C74.0347 144.231 72.8027 144.525 71.5333 144.828C71.3573 143.945 71.1813 143.063 71 142.153C72.3635 140.954 73.7303 139.767 75.1 138.587C75.4847 138.247 75.8693 137.907 76.2656 137.557C76.642 137.235 77.0184 136.913 77.4063 136.581C77.7498 136.283 78.0933 135.984 78.4473 135.676C79.7473 134.892 80.8272 134.977 82.2 135.021Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_2127_120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187 311C187 315 182 319 177 319C172 319 167 315 167 309C167 299 187 283 187 279C187 283 207 299 207 309C207 315 202 319 197 319C192 319 187 315 187 311Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2127_120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 224,
    height: 336,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2127_120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(17 17)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2127_120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 74,
    fill: "white",
    transform: "matrix(-1 0 0 -1 156.262 204.994)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2127_120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.262,
    height: 93.9887,
    fill: "white",
    transform: "matrix(-1 0 0 -1 121.262 214.989)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_2127_120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "matrix(-1 0 0 -1 207 319)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfH);
export default __webpack_public_path__ + "static/media/HalfH.a3641a4d5ca084ae29105d485f923fa5.svg";
export { ForwardRef as ReactComponent };